module.exports = __webpack_public_path__ + "static/media/apple-podcasts.73d1963d.svg";